// #region imports

// --- Angular
import { Component, Input, Output, EventEmitter } from '@angular/core';

// --- HS Code
import { ResultsViews } from '../../../models';

// #endregion

@Component({
  selector: 'hs-comparison-results-header',
  templateUrl: './comparison-results-header.component.html',
  styleUrls: ['./comparison-results-header.component.scss']
})
export class ComparisonResultsHeaderComponent {
  @Input() resultsDisplayMode: ResultsViews | null = null;
  @Input() isClicked: boolean = false;

  resultsViews = ResultsViews;

  @Output() viewChange = new EventEmitter<ResultsViews>();
  @Output() toggleCompareResultsModal = new EventEmitter<boolean>();
  @Output() downloadTrackMyJourneyClicked = new EventEmitter();
  @Output() openCompareResultsHint = new EventEmitter();

  onChartClick(): void {
    this.viewChange.emit(ResultsViews.chart);
  }

  onGridClick(): void {
    this.viewChange.emit(ResultsViews.grid);
  }

  onToggleCompareResultsModal() {
    this.toggleCompareResultsModal.emit(false);
  }

  onDownloadClick() {
    this.isClicked = true;
    this.downloadTrackMyJourneyClicked.emit();
  }

  onOpenCompareResultsHint() {
    this.openCompareResultsHint.emit();
  }
}
